/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CardLocked = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M18.5 10C20.0374 10 21.25 11.3473 21.25 12.9722V14H23V21H14V14H15.75V12.9722C15.75 11.3473 16.9626 10 18.5 10ZM21.5 15.5H15.5V19.5H21.5V15.5ZM19 3V8.5H2.5V15.5L12.499 15.5V17H1V3H19ZM10 12.5V14H4V12.5H10ZM18.5 11.5C17.8283 11.5 17.25 12.1425 17.25 12.9722V14H19.75V12.9722C19.75 12.1425 19.1717 11.5 18.5 11.5ZM17.5 4.5H2.5V6H17.5V4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
